import { render, staticRenderFns } from "./IkasIcon.vue?vue&type=template&id=57d50d53"
import script from "./IkasIcon.vue?vue&type=script&lang=js"
export * from "./IkasIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports